<div class="page_container">
  <ui-page-header [title]="'ftue.settings.title' | translate" [lucideIcon]="'Lightbulb'"></ui-page-header>
  <p class="page_description">{{ 'ftue.settings.description' | translate }}</p>

  <div class="tips-settings__content">

    <!-- ── Master switch ────────────────────────────────────────────────────── -->
    <section class="settings_section">
      <h2 class="section_title">{{ 'ftue.settings.tips_section' | translate }}</h2>

      <div class="tips-settings__row">
        <div class="tips-settings__copy">
          <span class="tips-settings__row-title">{{ 'ftue.settings.tips_toggle_label' | translate }}</span>
          <!-- The help line states what the current position means, so the
               switch does not have to be read as an abstract on/off. -->
          <span class="tips-settings__row-help">
            {{ (tipsEnabled ? 'ftue.settings.tips_toggle_on' : 'ftue.settings.tips_toggle_off') | translate }}
          </span>
        </div>
        <mat-slide-toggle
          color="primary"
          [checked]="tipsEnabled"
          (change)="onTipsEnabledChange($event.checked)">
        </mat-slide-toggle>
      </div>
    </section>

    <!-- ── Inventory ────────────────────────────────────────────────────────── -->
    <!-- Dimmed rather than hidden when tips are off: the switch's effect has to
         be visible, and the list stays readable as documentation. -->
    <section class="settings_section">
      <div class="table_card" [class.table_card--dimmed]="!tipsEnabled">
        <table class="settings_table">
          <thead>
            <tr>
              <th>{{ 'ftue.settings.inventory_count' | translate: { total: tips.length, seen: seenCount } }}</th>
              <th>{{ 'ftue.settings.col_trigger' | translate }}</th>
              <th>{{ 'ftue.settings.col_status' | translate }}</th>
              <th class="col_actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tip of tips">
              <td class="tips-settings__title-cell">{{ i18nKeys(tip.id).title | translate }}</td>
              <td class="tips-settings__trigger-cell">{{ i18nKeys(tip.id).trigger | translate }}</td>
              <td>
                <ui-status-badge
                  [label]="statusKey(tip) | translate"
                  [tone]="statusTone(tip)">
                </ui-status-badge>
              </td>
              <td class="col_actions">
                <!-- Icon-only row action: a labelled button competed with the
                     row's own title. The label survives as tooltip + aria-label. -->
                <button
                  type="button"
                  class="tips-settings__preview"
                  [matTooltip]="'ftue.settings.preview' | translate"
                  matTooltipPosition="left"
                  [attr.aria-label]="'ftue.settings.preview' | translate"
                  (click)="preview(tip)">
                  <ui-icon name="Eye" size="medium"></ui-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Reset lives inside the card it resets. Separate from the switch on
             purpose: neither action should silently do the other's job. -->
        <div class="tips-settings__reset">
          <div class="tips-settings__copy">
            <span class="tips-settings__row-title">{{ 'ftue.settings.reset_title' | translate }}</span>
            <span class="tips-settings__row-help">{{ 'ftue.settings.reset_help' | translate }}</span>
          </div>
          <ui-button
            type="secondary"
            icon="refresh"
            [label]="'ftue.settings.reset_action' | translate"
            (click)="resetHistory()">
          </ui-button>
        </div>
      </div>

      <!-- Written down rather than hidden: state is per user but stored per
           device, so a new browser may repeat a tip. -->
      <p class="tips-settings__caveat">{{ 'ftue.settings.device_caveat' | translate }}</p>
    </section>
  </div>
</div>
